'use client';

import FAQCategories from './faq-categories';
import FAQQuestions from './faq-questions';
const FAQContent = () => {
  return <div data-sentry-component="FAQContent" data-sentry-source-file="faq-content.tsx">
            <h1 className='mb-4 text-body-14 font-bold text-text-black lg:mb-6 lg:text-body-16'>پرسش‌های متداول</h1>

            <FAQCategories pageUrl='/faq' data-sentry-element="FAQCategories" data-sentry-source-file="faq-content.tsx" />

            <FAQQuestions data-sentry-element="FAQQuestions" data-sentry-source-file="faq-content.tsx" />
        </div>;
};
export default FAQContent;